// extracted by css-extract-rspack-plugin
export default {"setupButton":"T50bL"};